import React from "react";

import { cn } from "@/lib/utils";

import { CommandList as CommandListPrimitive } from "cmdk";

const CommandList = React.forwardRef<
  React.ElementRef<typeof CommandListPrimitive>,
  React.ComponentPropsWithoutRef<typeof CommandListPrimitive>
>(({ className, ...props }, ref) => (
  <CommandListPrimitive
    ref={ref}
    className={cn("relative top-0.5 w-full", className)}
    {...props}
  />
));

CommandList.displayName = CommandListPrimitive.displayName;
export { CommandList };
